import React, { useState, useCallback } from 'react';
import { Form, Button, Row, Col, Image, Alert } from 'react-bootstrap';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
// import uploadImage from '../../Services/azure-storage-blob';
import {uploadImage} from '../../Services/r2-storage-blob.js';


const ImageUpload = ({ label, images, setImages, maxImages = 10 }) => {
    const [uploading, setUploading] = useState(false);

    const handleFileSelect = useCallback(async (e) => {
        const files = Array.from(e.target.files);
        if (images.length + files.length > maxImages) {
            alert(`Maximum ${maxImages} images allowed`);
            return;
        }

        setUploading(true);
        
        for (const file of files) {
            // Validate file type
            if (!['image/jpeg', 'image/jpg', 'image/png', 'image/webp'].includes(file.type)) {
                alert(`${file.name} is not a supported format`);
                continue;
            }

            const tempId = Date.now() + Math.random();
            const newImage = {
                id: tempId,
                file,
                uploading: true,
                url: null,
                error: null,
                preview: URL.createObjectURL(file)
            };

            setImages(prev => [...prev, newImage]);

            try {
                const uploadedUrl = await uploadImage(file, file.name, 'parikrama-qa', 'images');
                setImages(prev => prev.map(img => 
                    img.id === tempId 
                        ? { ...img, uploading: false, url: uploadedUrl }
                        : img
                ));
            } catch (error) {
                setImages(prev => prev.map(img => 
                    img.id === tempId 
                        ? { ...img, uploading: false, error: 'Upload failed' }
                        : img
                ));
            }
        }
        
        setUploading(false);
        e.target.value = ''; // Reset input
    }, [images, maxImages, setImages]);

    const removeImage = useCallback((imageId) => {
        setImages(prev => prev.filter(img => img.id !== imageId));
    }, [setImages]);

    const retryUpload = useCallback(async (imageId) => {
        const image = images.find(img => img.id === imageId);
        if (!image) return;

        setImages(prev => prev.map(img => 
            img.id === imageId 
                ? { ...img, uploading: true, error: null }
                : img
        ));

        try {
            const uploadedUrl = await uploadImage(image.file, image.file.name, 'parikrama-qa', 'images');
            setImages(prev => prev.map(img => 
                img.id === imageId 
                    ? { ...img, uploading: false, url: uploadedUrl }
                    : img
            ));
        } catch (error) {
            setImages(prev => prev.map(img => 
                img.id === imageId 
                    ? { ...img, uploading: false, error: 'Upload failed' }
                    : img
            ));
        }
    }, [images, setImages]);

    const onDragEnd = useCallback((result) => {
        if (!result.destination) return;
        
        const newImages = Array.from(images);
        const [reorderedItem] = newImages.splice(result.source.index, 1);
        newImages.splice(result.destination.index, 0, reorderedItem);
        
        setImages(newImages);
    }, [images, setImages]);

    return (
        <Form.Group>
            <Form.Label>{label}</Form.Label>
            <Form.Control
                type="file"
                multiple
                onChange={handleFileSelect}
                accept="image/jpeg,image/jpg,image/png,image/webp"
                disabled={uploading || images.length >= maxImages}
            />
            
            {images.length > 0 && (
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="images">
                        {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef} className="mt-2">
                                <Row>
                                    {images.map((image, index) => (
                                        <Draggable key={image.id} draggableId={image.id.toString()} index={index}>
                                            {(provided) => (
                                                <Col md={3} className="mb-2"
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                >
                                                    <div className="position-relative">
                                                        <Image 
                                                            src={image.url || image.preview} 
                                                            thumbnail 
                                                            style={{ width: '100%', height: '100px', objectFit: 'cover' }}
                                                        />
                                                        
                                                        {image.uploading && (
                                                            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50">
                                                                <div className="spinner-border text-light" role="status"></div>
                                                            </div>
                                                        )}
                                                        
                                                        {image.error && (
                                                            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-danger bg-opacity-75">
                                                                <Button size="sm" variant="light" onClick={() => retryUpload(image.id)}>
                                                                    Retry
                                                                </Button>
                                                            </div>
                                                        )}
                                                        
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            className="position-absolute top-0 end-0"
                                                            onClick={() => removeImage(image.id)}
                                                        >
                                                            ×
                                                        </Button>
                                                    </div>
                                                </Col>
                                            )}
                                        </Draggable>
                                    ))}
                                </Row>
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            )}
        </Form.Group>
    );
};

export default ImageUpload;